import getWithToken from './base/get-with-token'

const getDevicesList = getWithToken('/devices')

export default getDevicesList